import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Container } from "reactstrap";
import moment from "moment";
import { getProjectChallengeList } from "../../api/casp/projectChallenge";
import Search from "../casp/common/Search";
import { PerPage } from "../../constants/Common";
import BreadCrumb from "../Common/BreadCrumb";

const ChallengesList = ({ t }) => {
  const columns = [
    {
      field: "index",
      headerName: "#",
      width: 85,
      filterable: false,
      sortable: true,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
          <div className="MuiDataGrid-cellContent">
            {params.row?.index}
          </div>
        </div>
      ),
    },
    {
      field: "description",
      headerName: t("Description"),
      width: 300,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
          <div className="MuiDataGrid-cellContent d-flex ">
            <span className="m-2 text-truncate" title={params.row?.description}>{params.row?.description}</span>
          </div>
        </div>
      ),
    },
    {
      field: "project_name",
      headerName: t("Startup Name"),
      width: 200,
      filterable: false,
      sortable: false
    },
    {
      field: "supportNeeded",
      headerName: t("Support Needed"),
      width: 300,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
          <div className="MuiDataGrid-cellContent">
            <span className="m-2 text-truncate" title={params.row?.supportNeeded}>{params.row?.supportNeeded}</span>
          </div>
        </div>
      ),
    },
    {
      field: "responsible",
      headerName: t("Responsible"),
      width: 200,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
          <div className="MuiDataGrid-cellContent">
            <span className="m-2 text-truncate" title={params.row?.responsible}>{params.row?.responsible}</span>
          </div>
        </div>
      ),
    },
    {
      field: "supportDate",
      headerName: t("Support Date"),
      width: 200,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className="MuiDataGrid-cellContent">
            {params.row?.supportDate ? moment(params.row?.supportDate).format("DD.MM.YY") : 'N/A'}
          </div>
        </div>
      ),
    },
  ]
  const [page, setPage] = useState(0);
  const [triggerData, setTriggerData] = useState(+new Date());
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isLoading, setIsLoading] = useState(false);
  const [stakeholderList, setStakeholderList] = useState([]);
  const navigate = useNavigate();
  const [search, setSearch] = useState("")
  const loggedInUser = useSelector((state) => state.Profile.user);

  const location = useLocation()

  useEffect(() => {
    const filterData = location?.state?.filterData ? JSON.parse(location.state?.filterData) : {}
    fetchStakeholderList({ ...filterData });
  }, [triggerData, location?.state?.filterData]);

  const fetchStakeholderList = async (params = {}) => {
    setIsLoading(true)
    try {
      if (params) {
        params = {
          ...params,
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      } else {
        params = {
          page: page + 1,
          perPage: rowsPerPage,
          ...(search && { search }),
        };
      }
      let level = ((page + 1) - 1) * rowsPerPage
      const res = (await getProjectChallengeList(params)).data.data;
      if (res.data.length > 0) {
        setStakeholderList(res.data.map((item) => ({
          index: ++level,
          id: item.id,
          project_name: item.project?.name,
          description: item.description,
          supportNeeded: item.supportNeeded,
          responsible: item.responsible,
          supportDate: item.supportDate
        })));
        setTotalRows(res.meta.total);
      } else {
        setStakeholderList([]);
        setTotalRows(0);
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    } finally {
      setIsLoading(false);
    }
  }

  // Global Search
  const globalSearch = async (params) => {
    setSearch(params.search);
    setTriggerData(+new Date());
  };

  const getRowId = (row) => row.id;

  const paginationModelMethod = async (data) => {
    setPage(data.page);
    setRowsPerPage(data.pageSize);
    setTriggerData(+new Date());
  };

  return (
    <React.Fragment>
      <div className="page-content position-relative">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center ongoingProjectsPg">
            <div className="mainPageHeader d-flex justify-content-between">
              <BreadCrumb title={t("Challenge List")} />
            </div>


            <div className="d-flex justify-content-end ongoingSearchField">
              <div className="position-relative">
                <Search
                  listCall={globalSearch}
                  params={{
                    page: 1,
                    perPage: rowsPerPage,
                  }}
                />
                {/* <SearchOutlinedIcon /> */}
              </div>
            </div>
          </div>
          <div className="accordionTable my-4" style={{ width: "100%" }}>
            {stakeholderList.length > 0 && (
              <DataGrid
                rows={stakeholderList}
                columns={columns}
                disableRowSelectionOnClick
                initialState={{
                  pagination: {
                    paginationModel: { pageSize: rowsPerPage },
                  },
                }}
                paginationMode="server"
                onPaginationModelChange={paginationModelMethod}
                rowCount={totalRows}
                pageSizeOptions={PerPage}
                getRowId={getRowId}
                loading={isLoading}
              />
            )}
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(ChallengesList)
